import { CompanyProfileFormModel } from 'src/Libs/company-settings/models'
import { Company } from 'src/State/User/UserModel'

/**
 * Returns a CompanyLocationAddressFormModel from a given Company
 *
 * Associating the switched address and place to the actual matching properties
 *
 * Which means an `address` is a `address` (the street), and the `place` is the place/city.
 *
 * Not the other way around
 *
 * @param model
 */
const companyModelToCompanyProfileFormTransformer = (model: Company): CompanyProfileFormModel => {
  return {
    address: model.contactData?.PlaceOR || '',
    emailAddress: model.contactData?.Email || '',
    fax: model.contactData?.Telefax || '',
    country: model.contactData?.Land || '',
    phone: model.contactData?.Telefon || '',
    place: model.contactData?.Address || '',
    zipCode: model.contactData?.PLZ || '',
    vatNumber: model.vatNumber || '',
    doDisplayInShowroom: model.doDisplayInShowroom || false,
  }
}
export default companyModelToCompanyProfileFormTransformer
